import React from "react";
export function arrayToOptions(arr, valField, textField) {
  let l =
    arr &&
    arr.length > 0 &&
    arr.map((obj, index) => {
      return (
        <option key={index} value={obj[valField]}>
          {obj[textField]}
        </option>
      );
    });
  return l;
}

export function createOptions(list, valProp, textProp, defaultItem) {
  let count = list.length;
  let options = [];
  if (count > 0) {
    options = list.map((item, index) => {
      return (
        <option key={index} value={item[valProp]}>
          {item[textProp]}
        </option>
      );
    });
  }

  if (defaultItem) {
    options.splice(
      0,
      0,
      <option key={count + 1} value={defaultItem["value"]}>
        {defaultItem["text"]}
      </option>
    );
  }

  return options;
}
